
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729477887197",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2287",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M256 74.666667a32 32 0 0 1 32 32v810.666666a32 32 0 0 1-64 0v-810.666666A32 32 0 0 1 256 74.666667zM768 74.666667a32 32 0 0 1 32 32v810.666666a32 32 0 0 1-64 0v-810.666666a32 32 0 0 1 32-32z",
        "p-id": "2288"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M224 512a32 32 0 0 1 32-32h512a32 32 0 0 1 0 64H256a32 32 0 0 1-32-32z",
        "p-id": "2289"
      }
    }
  ]
})
    }
  